<template>
    <div class="ls-billing-table--container">
        <div class="ls-billing-table--row header">
            <div
                v-for="headerName in ['', '#', 'Reference', 'Date', 'Note', '+', '-', 'Tax']"
                :key="headerName"
                class="ls-billing-table--cell"
                test-id="header-name"
            >
                {{ headerName }}
            </div>
        </div>
        <div
            v-for="(billingItem, billingItemIdx) in customerBilling"
            :key="billingItem.id"
            :class="['ls-billing-table--row', { odd: billingItemIdx % 2 !== 0 }]"
            test-id="row"
        >
            <div class="ls-billing-table--cell">
                <div class="ls-billing-table--cell--brand-wrapper">
                    <LsBrand
                        :brand="billingItem.brand"
                        :show-name="false"
                        style="display:inline-block"
                    />
                </div>
            </div>
            <div class="ls-billing-table--cell">
                <span class="ls-billing-table--item-info">
                    {{ billingItem.id }}
                </span>
            </div>
            <div class="ls-billing-table--cell">
                {{ billingItem.reference }}
                {{ billingItem.reference_id ? `#${billingItem.reference_id}` : '' }}
            </div>
            <div class="ls-billing-table--cell" test-id="date">
                {{ billingItem.created_at | timestamp }}
            </div>

            <div class="ls-billing-table--cell">
                <span class="ls-billing-table--item-info">{{ billingItem.note }}</span>
            </div>
            <div class="ls-billing-table--cell">
                <span v-if="billingItem.amount > 0" class="ls-billing-table--item-info">
                    {{ billingItem.amount | currency }}
                </span>
                <span v-else class="ls-billing-table--item-info">
                    -
                </span>
            </div>
            <div class="ls-billing-table--cell">
                <span v-if="billingItem.amount <= 0" class="ls-billing-table--item-info">
                    {{ (billingItem.amount * -1) | currency }}
                </span>
                <span v-else class="ls-billing-table--item-info">
                    -
                </span>
            </div>
            <div class="ls-billing-table--cell">
                {{ billingItem.tax | currency }}
            </div>
        </div>
    </div>
</template>

<script>
import VueTypes from 'vue-types';
import { lsPropTypeHelpers } from 'ls-vue-common';
import LsBrand from '@/components/LsBrand/LsBrand.vue';

export default {
    name: 'LsBillingTable',
    components: {
        LsBrand,
    },
    props: {
        customerBilling: VueTypes.arrayOf(
            VueTypes.shape({
                __typename: VueTypes.string.isRequired,
                id: VueTypes.string.isRequired,
                reference: VueTypes.string.isRequired,
                reference_id: VueTypes.number.isRequired,
                reference_subcategory: VueTypes.custom(lsPropTypeHelpers.stringOrNull).isRequired,
                note: VueTypes.string.isRequired,
                amount: VueTypes.number.isRequired,
                tax: VueTypes.number.isRequired,
                fee: VueTypes.number.isRequired,
                created_at: VueTypes.string.isRequired,
            })
        ),
    },
};
</script>

<style lang="scss" scoped>
.ls-billing-table--container {
    font-size: $size-5;
    margin: 15px 0;
    color: $secondary;
    background-color: $white;
}

.ls-billing-table--row {
    display: flex;
    justify-content: flex-start;

    font-weight: $light;

    &.odd {
        background-color: $secondary-lighter;
    }
    &.header {
        font-weight: $medium;
        border-top: none;
        cursor: default;
    }

    &.extra-property {
        .ls-billing-table--item-info {
            display: none;
        }
    }

    .ls-billing-table--cell {
        padding: 20px 10px 10px 10px;
        border: 0.5px solid $table-border;

        &:nth-child(1) {
            width: 5%;
        }
        &:nth-child(2) {
            width: 8%;
        }
        &:nth-child(3) {
            width: 13%;
        }
        &:nth-child(4) {
            width: 17%;
        }
        &:nth-child(5) {
            width: 35%;
        }
        &:nth-child(6) {
            width: 8%;
        }
        &:nth-child(7) {
            width: 8%;
        }
        &:nth-child(8) {
            width: 6%;
        }

        @media (max-width: $tablet-max-width) {
            &:nth-child(1) {
                width: 8%;
            }
            &:nth-child(2) {
                width: 10%;
            }
            &:nth-child(3) {
                width: 19%;
            }
            &:nth-child(4) {
                width: 11%;
            }
            &:nth-child(5) {
                width: 26%;
            }
            &:nth-child(6) {
                width: 9%;
            }
            &:nth-child(7) {
                width: 9%;
            }
            &:nth-child(8) {
                width: 8%;
            }
        }

        .ls-billing-table--cell--brand-wrapper {
            text-align: center;
        }
    }
}
</style>
